function getSize({ title }) {
  const [size] = title.split(' ');
  return { size };
}

function getHeightAndWidth({ size }) {
  const [height, width] = size.split('x').map(num => parseInt(num, 10));
  return { height, width };
}

function getOrientation({ title }) {
  const { size } = getSize({ title });
  const { height, width } = getHeightAndWidth({ size });

  if (height > width) {
    return 'portrait';
  }
  if (height === width) {
    return 'square';
  }
  return 'landscape';
}

export default getOrientation;
